<template>
    <div class="message-item" :class="[messageOwner? 'my-message': 'my-inbox']">
        <div class="white-space-pre-line word-break-break-word">
            <span class="address-link" v-if="message && externalLink(message.message)" v-html="externalLink(message.message)"></span>   
            <span v-else>{{message.message}}</span> 
        </div>
        <div class="message-item-footer ml-auto">
            <p>
                {{message.createdAt | toChatDateFormat}}
            </p>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import {dates} from '../../../core/filters'

export default {
    name: 'MessageItem',
    props: {
        message: Object
    },
    filters: {
        toChatDateFormat: dates.toChatDateFormat
    },
    computed: {
        ...mapState([
            'user'
        ]),
        messageOwner() {
            return this.message.uid === this.user.uid
        }
    },
    methods: {
        externalLink: (textToCheck) => {
            if(/<\/?[a-z][\s\S]*>/i.test(textToCheck)){
                return null
            }
            let expression = /(https?:\/\/)?[\w\-~]+(\.[\w\-~]+)+(\/[\w\-~@:%]*)*(#[\w\-]*)?(\?[^\s]*)?/gi;
            let regex= new RegExp(expression);
            let match = ''; 
            let splitText = []; 
            let startIndex = 0;
            let content = ''
            while ((match = regex.exec(textToCheck)) != null) {
                splitText.push({text: textToCheck.substr(startIndex, (match.index - startIndex)), type: 'text'});
                let cleanedLink = textToCheck.substr(match.index, (match[0].length));
                cleanedLink = cleanedLink.replace(/^https?:\/\//,'');
                splitText.push({text: cleanedLink, type: 'link'});
                startIndex = match.index + (match[0].length);               
            }
            if (startIndex < textToCheck.length) splitText.push({text: textToCheck.substr(startIndex), type: 'text'});
            splitText.forEach(el => {
                if(el.type === 'text') {
                    content += el.text
                }
                else if(el.type === 'link'){
                    content += `<a  href="https://${el.text}" target="_blank">${el.text}</a>` 
                }
            })
            return content
        },
    },
}
</script>
<style lang="scss" scoped>
div.message-item {
    padding: 32px 32px 0 32px;
    max-width: 400px;
    border: 1px solid #EAEEF1;
    margin-top: 24px;
    position: relative;
    word-break: break-all;
    display: flex;
    flex-direction: column;
    span {
        font-size: 13px;
        font-weight: 400;
    }
    &.my-message {
        background: #727CF5;
        box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.05);
        border-radius: 10px;
        margin-left: auto;
        span {
            color: #FFFFFF;
        }
        &::after {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            border-bottom: 30px solid #727CF5;
            border-right: 30px solid transparent;
            left: 100%;
            top: 100%;
            transform: translate(-15px, -100%);
        }
        div.message-item-footer  {
            p {
                color: #ffffff;
            }
        }
    }
    &.my-inbox {
        background: #FFFFFF;
        box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.05);
        border-radius: 10px;
        margin-right: auto;
        
        &::before {
            content: "";
            position: absolute; 
            width: 0;
            height: 0;
            border-bottom: 30px solid #FFFFFF;
            border-left: 30px solid transparent;
            right: 100%;
            top: 100%;
            transform: translate(15px, -100%);
            box-shadow: -3px 4px 0px -3px rgba(0, 0, 0, 0.05);
        }
        span {
            color: #333333;
        }
        div.message-item-footer  {
            p {
                color: #333333;
            }
        }
    }
    div.message-item-footer  {
        margin-top: 14px;
        margin-bottom: 10px;
        p {
            font-size: 11px;
            margin-bottom: 0;
        }
    }
}
</style>

<style lang="scss" >
.message-item {
    a {
        text-decoration: underline !important;

        &:hover {
            text-decoration: underline !important;
        }
    }
    &.my-message {
        .address-link {
            a {
                color: #F1F2FE!important;

                &:hover {
                    color: #FFF!important;
                }
            }
        }
    }
}
</style>